import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ConfigService } from '@services/config/config.service';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import * as $ from 'jquery';
import { SclUtilMapService } from 'projects/formbird-mapping/src/lib/scl-util-map.service';
import { HttpService } from '../../../../formbird-mapping/src/lib/http.service';
import { SclMapConstantService } from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import { SclMappingFunctionsService } from '../../../../formbird-mapping/src/lib/scl-mapping-functions.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { SclAddressUtilService } from '../../../../formbird-sc-shared/src/lib/scl-address-util.service';
import { NotificationService } from '../../../../formbird-services/src/lib/services/notification/notification.service';
import { SearchService } from '../../../../formbird-services/src/lib/services/search/search.service';
import {isEqual, cloneDeep, find} from 'lodash';
import { AddressDetails } from '../../../../formbird-mapping/src/lib/AddressDetails';
import { BoundaryComponentDefinition } from './boundary.component.definition';
import {sclHandlebars} from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import { MapLibraryName, MapComponentName, MapDrawAction, MapDrawType } from '../../../../formbird-mapping/src/lib/map-library';


@Component({
  templateUrl: './boundary.component.html',
  styleUrls: [
    './boundary.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoundaryComponent extends AbstractComponent<BoundaryComponentDefinition> implements OnInit, AfterViewInit {
  @ViewChild('map', {static: false}) divMap: ElementRef;
  @ViewChild('mapView', {static: false}) divMapView: ElementRef;
  @ViewChild('info', {static: false}) divInfo: ElementRef;
  @ViewChild('info1', {static: false}) divInfo1: ElementRef;
  @ViewChild('infoCluster', {static: false}) divInfoCluster: ElementRef;
  @ViewChild('tooltipInfo', { static: false }) tooltipInfo: ElementRef;

  // service
  loggedInUserService: any;


  actionType;
  color: any = 'black'; multiColor: any = 'red';
  defaultLat; defaultLon; defaultZoom;
  disableMouseWheel: any = false; proj: any = ''; timeOutDelay: any = 1000;
  hideAddress = true;
  geocodeSearchService = [];
  apiKey;
  geocodeURL = 'https://www.geocode.farm/v3/json/reverse/';
  keyName; results; debounce; searchMinLength; mapFunc;
  mapLibName = MapLibraryName.OPEN_LAYER; googleKey;  mapParameters; target; divWrapper; zoomFloor; mapGeo; autoCompleteBox;
  searchZoom; // 14479#0053120 ( just use for comp-dev )
  layerIds;
  isComponentReady = false;
  addressMarker = SclMapConstantService.MAP_MARKER;
  isDrawCircleAsPolygon = false;
  geoJsonField = '';
  isMapReady; // 14781#c55330
  loadAssetCounter = 0;
  layersRedraw = false;
  intervalToolTipSetup = null; countIntervalTooltipSetup = 0; hasCustomControl = false; // 15336#c59379
  isPopupClusterOpen = false; isClusterPopupScroll; clusterList: any = []; clusterMarkersClicked = []; allowSelectAsset; // 15251
  toolTipTimeout = undefined;
  tooltipsTimeout = null;
  previousSelectedFeature;
  focusPopup;
  currentPopover = null;
  tooltipText;
  toolTipZIndex = 100;
  disablePopupOkButton;
  postList: any = [];
  isRadioPopupScroll;
  streetDataComp;
  hasOnFieldValueChange = false;
  private searchClientService: any;
  initialAssetLoading = true; // 20117
  
  disableAddress = false;
  hasMapWheelScroll = false;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    private searchService: SearchService,
    protected cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    private httpClient: HttpClient,
    private httpService: HttpService,
    private notificationService: NotificationService,
    private configService: ConfigService,
    private sclAddressUtilService: SclAddressUtilService,
    private sclUtilMapService: SclUtilMapService,

  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService');

    this.mapFunc = new SclMappingFunctionsService(httpClient, cdRef, notificationService);
    this.mapFunc.createFeature = this.createFeature.bind(this);
    this.mapFunc.updateAddress = this.updateAddress.bind(this);
  }
  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);
    this.mapFunc.tooltipHandleBarObjects = [];

    this.keyName = this.fieldName + this.template.documentId;

    this.results = {};


    this.setWatchReadOnly();
    this.initMap();

    this.setupChangeDetection();

    const panelSub = this.broadcastService.on('panel-comp-def-updated').subscribe((data) => {
      console.log('On panel component def updated.......', data);
      if (data?.startKey < this.key && this.key < data?.endKey) {
        if (this.componentDefinition.visible !== false) {
          if (this.mapLibName === MapLibraryName.OPEN_LAYER && this.mapFunc) {
            this.mapFunc.showMap();
            console.log('Show Map called.');
          }
        }
      }
    });
    this.subs.add(panelSub);

  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.mapFunc.unregisterMapWrapperChange(this.divMap);
  }

  initializeFieldValue() {
    if (!this.fieldValue) {
      if (this.streetDataComp) {
        this.streetDataComp.streetData = null;
        this.initStreetData();
      }

    }
  }
  initStreetData() {
    if (!this.streetDataComp.streetData) {
      this.streetDataComp.streetData = {};
      this.streetDataComp.streetData[this.keyName] = new AddressDetails();
    }
    this.sclAddressUtilService.resetAddressData(this.streetDataComp.streetData[this.keyName]);
    console.log('resetAddressData');
  }

  onFieldValueChanged(fieldValue) {
    // console.log(`*** this.fieldValue = ${JSON.stringify(this.fieldValue)}`);
    // console.log(`*** fieldValue = ${JSON.stringify(fieldValue)}`);
    // console.log(`*** this.document[${this.fieldName}] = ${JSON.stringify(this.document[this.fieldName])}`);
    if (!isEqual(this.document[this.fieldName], fieldValue) ) {
      console.log(`**** onFieldValueChanged, update new value for this.document[${this.fieldName}]`);
      this.mapFunc.mapObj.hasDocumentChangeValue = true;
      this.document[this.fieldName] = cloneDeep(fieldValue);
      if (typeof this.mapFunc.mapObj.checkAndDrawGeoJson === 'function') {
        this.mapFunc?.mapObj?.checkAndDrawGeoJson(cloneDeep(fieldValue));
      }
    }
    // override to do nothing
    if (!fieldValue) {
      if (!this.streetDataComp) {
        this.hasOnFieldValueChange = true;
      } else {
        this.fieldValueChanged();
      }

    }
  }
  fieldValueChanged() {
    if (this.streetDataComp) {
      this.streetDataComp.streetData = null;
      this.initStreetData();
      this.detectChanges();
    }

  }
  onComponentDefChanged(componentDefinition) {

    super.onComponentDefChanged(componentDefinition);

    if (((typeof componentDefinition.visible === 'undefined') || componentDefinition.visible === null)
      || componentDefinition.visible) {
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        this.mapFunc.showMap();
      }
    }

    const obj = this.sclUtilMapService.checkDisableAddressEntry(this.componentDefinition, this.geocodeSearchService);
    this.mapFunc.isDisableAddressEntry = obj.disableAddressEntry;

    if (this.disabled == false) {
      this.mapFunc.setActivateButtonLookupAddress();
    }

    this.mapFunc?.switchMapView(this.componentDefinition?.mapParameters?.showMapView, this.keyName);
    
    this.cdRef.detectChanges();
  }

  initMap() {
    // Debounce settings for address entry
    this.debounce = SclMapConstantService.DEFAULT_SEARCH_DELAY;
    if (this.configService.clientConfig().searchDelay) {
      this.debounce = this.configService.clientConfig().searchDelay;
    }
    
    this.searchMinLength = SclMapConstantService.DEFAULT_SEARCH_LENGTH;

    if (this.mapLibName === MapLibraryName.GOOGLE) {
      this.mapFunc.maxZoomAsset = 20;
      this.mapFunc.minZoomAsset = 15;
    } else if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      this.mapFunc.maxZoomAsset = 16;
      this.mapFunc.minZoomAsset = 9;
    }

    if (this.componentDefinition) {
      if (this.componentDefinition.maxZoom) { this.mapFunc.maxZoomAsset = this.componentDefinition.maxZoom; }
      if (this.componentDefinition.minZoom) { this.mapFunc.minZoomAsset = this.componentDefinition.minZoom; }

      if (this.componentDefinition.searchDelay) {
        this.debounce = this.componentDefinition.searchDelay;
      }
      if (this.componentDefinition.searchMinLength) {
        this.searchMinLength = this.componentDefinition.searchMinLength ;
      }
      if (this.componentDefinition.isDrawCircleAsPolygon) {
        this.isDrawCircleAsPolygon = this.componentDefinition.isDrawCircleAsPolygon;
      }

      if ( this.componentDefinition.disableMouseWheel) {
        this.disableMouseWheel = this.componentDefinition.disableMouseWheel;
      }
      if (this.componentDefinition.color) {
        this.color = this.componentDefinition.color;
      }
      if (this.componentDefinition.multiColor) {
        this.multiColor = this.componentDefinition.multiColor;
      }
      if ( this.componentDefinition.proj) {
        this.proj = this.componentDefinition.proj;
      }
      if (this.componentDefinition.addressEntry) {
        this.hideAddress = !this.componentDefinition.addressEntry;
      }
      if (this.componentDefinition.geocodeSearchService) {
        this.geocodeSearchService = this.componentDefinition.geocodeSearchService;
      }
      if (this.componentDefinition.disableAddress) {
        this.disableAddress = this.componentDefinition.disableAddress;
      }
      if (this.componentDefinition.mapParameters) {
        this.mapParameters = this.componentDefinition.mapParameters;
        if (this.mapParameters.EPSG) {
          this.mapFunc.EPSG = this.mapParameters.EPSG;
        }
        if (this.mapParameters.searchZoom) {
          this.searchZoom = this.mapParameters.searchZoom;
        }
      }
      if (this.componentDefinition.zoomFloor) {
        this.zoomFloor = this.componentDefinition.zoomFloor;
      }

      if (this.componentDefinition.layers) {
        let idx = 0;
        for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
          idx++;
          // 1. logic for options updateWatchFieldsLayer independence with logic 2. , put in this loop for performance
          if (typeof this.componentDefinition.layers[i].updateWatchFields !== 'undefined') {
            for (let j = 0; j < this.componentDefinition.layers[i].updateWatchFields.length; j++) {
              const key = this.componentDefinition.layers[i].updateWatchFields[j];
              if (key in this.mapFunc.updateWatchFieldsLayer) {
                if (this.mapFunc.updateWatchFieldsLayer[key].indexOf(idx) > -1 ) { continue; }

                this.mapFunc.updateWatchFieldsLayer[key].push(idx);

              } else {
                this.mapFunc.updateWatchFieldsLayer[key] = [idx];
              }
            }
            this.mapFunc.hasUpdateWatchField = true;
          }

          // 2. another logic for layerAssets independence with logic 1.
          let isHeatMap = false;
          if (this.componentDefinition.layers[i].type && this.componentDefinition.layers[i].type === 'heatmap') {
            isHeatMap = true;
          }
          this.mapFunc.layerAssets.push({query: this.componentDefinition.layers[i].filter + '_layer_' + idx, i: idx
            , isHeatMap, layer: this.componentDefinition.layers[i], isFilter: false
            , currentFilter: this.componentDefinition.layers[i].filter, features: []});

        }
      }
      if (this.componentDefinition.geoJsonField) { this.geoJsonField = this.componentDefinition.geoJsonField; }
      if (this.componentDefinition.filter) {
        const layerIndex = (this.componentDefinition.layers ? this.componentDefinition.layers.length + 1 : 1);
        const layerFilter = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.geoJsonField);
        this.mapFunc.layerAssets.push({query: this.componentDefinition.filter + '_filter_' + layerIndex, i: layerIndex
          , isHeatMap: false, layer: layerFilter, isFilter: true
          , currentFilter: this.componentDefinition.filter, features: [] });
      }
      if (this.componentDefinition.showTiming) {
        this.mapFunc.showTiming = this.componentDefinition.showTiming;
      }
      if (!(typeof this.componentDefinition.tooltipsTimeout === 'undefined' ||
      this.componentDefinition.tooltipsTimeout === null)) {
        this.tooltipsTimeout = this.componentDefinition.tooltipsTimeout;
      }

      if ( !(typeof this.componentDefinition.initialAssetLoading === 'undefined' ||
      this.componentDefinition.initialAssetLoading === null) ) {
        this.initialAssetLoading = this.componentDefinition.initialAssetLoading;
      }

      if (this.componentDefinition.queryPageSize) {
        this.mapFunc.pageSize = this.componentDefinition.queryPageSize; // 14603 : override assetField.maxVectorItems
      }
      if (!(typeof this.componentDefinition.disableHandlebars === 'undefined' ||
        this.componentDefinition.disableHandlebars === null)) {
          this.mapFunc.disableHandlebars = this.componentDefinition.disableHandlebars;
      }// 15250
  
      // test re-draw layer
      if (this.componentDefinition.layersRedraw) { this.layersRedraw = this.componentDefinition.layersRedraw; }
    }
    
    sclHandlebars.initHandlebars(this.componentDefinition.handlebarsHelpers);
    this.mapFunc.addressId = this.keyName + '_address';
    this.mapFunc.contextParams = {
      doc : this.document,
      account: this.loggedInUserService.user.account,
      tpl: this.template,
      tplItem: this.componentDefinition
    };

    if (this.componentDefinition.heightNum && this.componentDefinition.heightNum > 0) {
      let height = 180 * this.componentDefinition.heightNum;
      const docHeight = $(document).height();
      if (height > (docHeight - 180)) {
        height = docHeight - 180;
      }
      this.mapFunc.mapHeight = height + 'px';
    } else {
      this.mapFunc.mapHeight = '180px';
    }

    // init map
    this.googleKey = null;
    if (this.mapParameters) {
      this.defaultLat = this.mapParameters.defaultLat;
      this.defaultLon = this.mapParameters.defaultLon;
      this.defaultZoom = this.mapParameters.defaultZoom;

      if (this.mapParameters.mapViews) {
        for (let i = 0; i < this.mapParameters.mapViews.length; i++) {
          if (this.mapParameters.mapViews[i].serverType === MapLibraryName.GOOGLE) {
            this.mapLibName = MapLibraryName.GOOGLE;
            this.googleKey = (typeof this.mapParameters.mapViews[i].apiKey === 'undefined' ||
              this.mapParameters.mapViews[i].apiKey === null) ? null : this.mapParameters.mapViews[i].apiKey;
            if (this.googleKey == null) { console.error('Google map key is null'); }
            break;
          }
        }
      } else {
        this.mapParameters.mapViews = SclMapConstantService.DEFAULT_MAP_PARAMETERS.mapViews;
      }
    } else {
      this.mapParameters = SclMapConstantService.DEFAULT_MAP_PARAMETERS;
    }


  }

  ngAfterViewInit() {
    this.mapFunc.divInfo = this.divInfo;
    this.mapFunc.divInfo1 = this.divInfo1;
    this.mapFunc.divInfoCluster = this.divInfoCluster;

    this.target = this.divMap.nativeElement;
    this.divWrapper = this.divMapView.nativeElement;

    const mapId = this.keyName + 'map';
    const targetMap = document.getElementById(mapId); // target
    this.mapFunc.targetMapElement = targetMap;

    this.mapFunc.registerMapWrapperChange(this.divMap, this.onMoveEnd.bind(this));

    this.mapFunc.initLib(this.mapFunc, this.mapLibName , {googleKey: this.googleKey}
      , async (mapObj) => {
        console.log('************* done load map **************');
        this.isComponentReady = true;
        this.detectChanges(); // to make isParentReady of geo-aut-complete updated
        this.mapFunc.mapObj = mapObj;

        // multiple mapView
        this.mapFunc.multiLayers(this.mapParameters); // add multiple map views
        const mapId = '#' + this.keyName + 'map';
        this.layerIds = [];

        await this.mapFunc.setupMap(this.mapFunc, {target: this.target,
          disableMouseWheel : this.disableMouseWheel, defaultLon: this.defaultLon
            , defaultLat: this.defaultLat, defaultZoom: this.defaultZoom, color: this.color
            , multiColor: this.multiColor, actionType: this.actionType, divWrapper: this.divWrapper
            , maxZoom: this.componentDefinition.maxZoom
            , formatGeoJSON: this.document[this.fieldName] // load saved data
            , EPSG: this.mapFunc.EPSG
            , minResolution: this.mapParameters.minResolution, maxResolution: this.mapParameters.maxResolution
            , style: MapComponentName.BOUNDARY, mapId: mapId
            , setDirty: this.setDirty.bind(this)
            , heightNum : (this.componentDefinition.heightNum ? this.componentDefinition.heightNum : null)
            , zoomFloor: this.zoomFloor
            , componentDefinition : this.componentDefinition
            , configService: this.configService
            , isDrawCircleAsPolygon: this.isDrawCircleAsPolygon
            , layerAssets: this.mapFunc.layerAssets
            , intervalToolTipSetup: this.intervalToolTipSetup
            , countIntervalTooltipSetup: this.countIntervalTooltipSetup
            , hasCustomControl: this.hasCustomControl
            , setupTooltipUI: this.mapFunc.setupTooltipUI.bind(this.mapFunc)
            , toolTipOnFeatureHover: (e) => {
              this.mapFunc.tooltipOnFeatureHover(e, this.mapLibName);
            }
            , tooltipInfo: this.tooltipInfo
            , cdRef: this.cdRef
            , watcherFunction: (doc) => {
              // 16772#0068539
              if (!isEqual(this.document, doc)) {
                this.document = cloneDeep(doc);
                this.mapFunc.contextParams.doc = this.document;
              } else {
                console.log('happenning watch document but new Value = old Value');
              }
            }
            , onMapWheelScroll: this.onMapWheelScroll.bind(this)
          }, this.keyName
        );


        // load asset
        const allowLoadAsset = (!this.mapFunc.disableProcessingOnLoad && this.initialAssetLoading) ? true : false;

        if (this.isMapReady == null) {
          this.isMapReady = setInterval(() => {
            if (this.mapFunc.mapObj.isMapReady) {
              this.mapFunc.resetupTooltipUI();
              clearInterval(this.isMapReady);
              this.isMapReady = null; // reset
              if (allowLoadAsset) {
                this.loadAsset('mapReady', true);
              }
              this.mapFunc.mapObj.mapMoveEnd(this.onMoveEnd.bind(this));
              this.mapFunc.mapObj.addControlDraw(this.keyName
                , this.mapFunc.mapObj.mapViewLayers
                , (obj) => {
                  this.layerIds = obj.layerIds;
                  this.mapFunc.pencilElements.push(obj.menuSelectBtn);
                  this.mapFunc.pencilElements.push(obj.menuSelectLabel);

                  if (this.disabled == false) {
                    this.mapFunc.setActivateButtonLookupAddress();
                  }
              });
            }
          }, 200);
        }


        this.mapFunc.mapObj.mapClickEvent((evt) => {
          // console.log("map click event, action type = " + scope.MapFunc.mapObj.actionType);
          if (this.mapFunc.mapObj.actionType === MapDrawAction.DELETE) {
            this.mapFunc.mapObj.drawActionDelete(evt);
          } else if (this.mapFunc.mapObj.actionType === MapDrawAction.PROPERTIES) {
            this.mapFunc.mapObj.drawActionProperties(evt);
          }
        });

        if (this.document && this.document[this.fieldName]) {
          try {
            this.mapFunc.fitCoords(this.document[this.fieldName].features);
          } catch (err) {
            console.log(err);
          }
        }


        // tooltip
        this.mapFunc.mapObj.mapPointerMoveEvent( (evt) => {
          if (evt.dragging) {
            this.mapFunc.hasMapDragging = evt.dragging;
            if (this.mapFunc?.hasMapDragging) {
              this.mapFunc.subLabelTiming = "On-map-pointer-move-end";
            }
            return;
          }

          this.mapFunc.lastEvt = evt;
          if (!this.mapFunc.mouseStopInterval && (!this.mapFunc.focusPopup || !this.mapFunc.currentPopover)) {
            this.mapFunc.mouseStopInterval = setInterval(() => {
              this.mapFunc.hasMouseStopped(evt);
            }, 450);

          }
        });

      }, this.changedDocumentService, this.subs, this.document); // finish init map

    $(this.mapFunc.targetMapElement).on('mouseleave', this.onMapMouseLeave.bind(this)); // tooltip

    this.detectChanges();
    this.broadcastService.broadcast('disabled', this.disabled);
  }
  onMapMouseLeave() {
    if (this.mapFunc.isPopoverOpen) {
      this.mapFunc.dismissPopover();
    }
  }

  setDirty() {
    // console.log(`*** setDirty , this.mapFunc?.mapObj?.hasDocumentChangeValue = ${this.mapFunc.mapObj.hasDocumentChangeValue}`);
    if (this.mapFunc?.mapObj?.hasDocumentChangeValue) {
      return;
    }
    if (!this.document[this.fieldName]) {
      this.document[this.fieldName] = {};
    }
    if (this.document[this.fieldName]) {

      this.document[this.fieldName].modified = true;

      this.mapFunc.mapObj.getGEOJSON((data) => {
        if (data.features.length > 0) {
          for (let i = data.features.length - 1; i > -1; --i) {
            if (typeof data.features[i].id === 'undefined' ) { continue; }

            data.features.splice(i, 1);
          }

        }

        this.valueChanged(data);
      });
    }
  }


  // begin logic for geo-auto-complete
  initGeoAutoComplete(e) {
    this.mapFunc.geoAutoComplete = e.geoAutoComplete;
    this.mapGeo = this.mapFunc.geoAutoComplete.mapGeo;
    this.mapFunc.isDisableAddressEntry = this.mapFunc.geoAutoComplete.isDisableAddressEntry;
  }
  // end logic for geo-auto-complete

  bindAddress(streetData) {
    if (this.streetDataComp) {
      this.streetDataComp.streetDataStr = JSON.stringify(streetData);
      this.streetDataComp.bindStreetData(this.hideAddress);
      this.detectChanges();
    }

  }

  updateAddress(lat, lng) {
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    let st: any = new AddressDetails();
    if (!st.geometry || !st.geometry.coordinates) {
      st.geometry = {
        coordinates: [],
        type: MapDrawType.POINT
      };
    }
    st.geometry.coordinates[0] = lng;
    st.geometry.coordinates[1] = lat;
    if (this.streetDataComp) {
      this.streetDataComp.streetData[this.keyName] = st;
    }
    this.detectChanges();

    this.mapFunc.mapObj.updateLocation(lat, lng, this.mapFunc.addressId, this.addressMarker, 'address'
      , this.mapFunc.addressId, false);

    if (this.mapGeo) { // use geocodeSearchService
      this.mapGeo.reverse([lng, lat]
        , (streetData) => {
          this.mapFunc.hasMapDragging = true;
          this.mapFunc.subLabelTiming = 'Get-Street-Data-By-Click-To-Map';

          if (streetData) {
            st = streetData;
          }
          this.bindAddress(st);
        }
        , (err) => {
          console.log('error = ' + err);
          this.bindAddress(st);
        });
    } else { // use default geo api
      const link = this.sclUtilMapService.getGeocodeCoordinate(this.geocodeURL, lat, lng, this.componentDefinition, this.apiKey);
      this.httpClient.get(link).subscribe(res => {
          const data = (res as any);
          if (data && data.geocoding_results.STATUS.status === 'SUCCESS') {
            const suggestions = data.geocoding_results.RESULTS[0];
            const address = suggestions.ADDRESS;
            st.properties.streetNo = address.street_number;
            st.properties.street = address.street_name;
            st.properties.suburb = address.locality;
            st.properties.postcode = address.postal_code;
            st.properties.country = address.country;
            st.properties.state = address.admin_1;
            st.geometry.coordinates[0] = lng;
            st.geometry.coordinates[1] = lat;
          }
          this.bindAddress(st);
        },
        error => {
          console.log('Error : ' + error);
          this.bindAddress(st);
        });
    }
  }

  fillGoogleAddress(data) {
    const self = this;
    if (self.streetDataComp) {
      self.sclAddressUtilService.resetAddressData(self.streetDataComp?.streetData);
      for (let i = 0; i < data.address_components.length; i++) {
        const addressType = data.address_components[i].types[0];
        const val = data.address_components[i].long_name;
        if (addressType === 'subpremise') {
          self.streetDataComp.streetData.properties.unitNo = val;
        } else if (addressType === 'street_number') {
          self.streetDataComp.streetData.properties.streetNo = val;
        } else if (addressType === 'route') {
          self.streetDataComp.streetData.properties.street = val;
        } else if (addressType === 'administrative_area_level_1') {
          self.streetDataComp.streetData.properties.state = val;
        } else if (addressType === 'locality') {
          self.streetDataComp.streetData.properties.suburb = val;
        } else if (addressType === 'postal_code') {
          self.streetDataComp.streetData.properties.postcode = val;
        } else if (addressType === 'country') {
          self.streetDataComp.streetData.properties.country = val;
        }
      }
    }

  }

  onGetStreetData(streetData: any) {
    this.mapFunc.hasMapDragging = true;

    this.streetDataComp.streetData[this.keyName] = new AddressDetails();
    if (this.mapGeo != null) {
      this.mapGeo.removeFeatures();
    }
    if (streetData == null) {
      return;
    }
    this.streetDataComp.streetData[this.keyName] = streetData;
    const lat = streetData.geometry.coordinates[1]; const lon = streetData.geometry.coordinates[0];
    
    this.mapFunc.mapObj.updateLocation(lat, lon, this.mapFunc.addressId, this.addressMarker, 'address'
      , this.mapFunc.addressId, false);

    this.mapFunc.mapObj.zoomToLocation(lat, lon);
    this.mapFunc.mapObj.zoomToValue(this.searchZoom); // 14479#0053120 ( just use for comp-dev )

    this.streetDataComp.bindStreetData(this.hideAddress);
    this.detectChanges();

  }

  onRemoveStreetCb() {
    console.log('library , remove street call back');
    this.initStreetData();

    const fea = this.mapFunc.mapObj.getFeatureById(this.mapFunc.addressId);
    console.log(`**** fea = `, fea);
    if (fea) {
      this.mapFunc.mapObj.removeLocation(fea);
      this.resetAddressData();
    }
    else {
      this.resetAddressData();
    }
  }
  resetAddressData() {
    if (this.streetDataComp && this.streetDataComp.streetData[this.keyName]) {
      this.streetDataComp.streetData[this.keyName] = new AddressDetails();

      this.streetDataComp?.bindStreetData(this.hideAddress);
    }
  }

  setWatchReadOnly() {
    const self = this;
    const readOnlySub = self.broadcastService.on('disabled').subscribe((newValue) => {
      const timeOutDelay = 3000;
      setTimeout(() => {
        self.setFieldActivation();
      }, timeOutDelay);
    });
    this.subs.add(readOnlySub);
  }

  setFieldActivation() {
    if (this.disabled) {

      $(this.target).find('button')
        .map((index, elem) => {
          if (this.layerIds.indexOf(elem.id) > -1) {
            const style = $(elem).attr('style') + ';cursor:not-allowed';
            $(elem).attr('disabled', 'true').attr('style', style);
          }
        });
      $('div[class*="disableElement"]').css(
        {opacity: '0.92', cursor: 'not-allowed', 'pointer-events': 'none'});
    } else {

      $(this.target).find('button')
        .map((index, elem) => {
          const style = $(elem).attr('style') + ';cursor:pointer';
          // console.log("style = " + style);
          $(elem).removeAttr('disabled');
          $(elem).attr('style', style);
        });
    }
    this.mapFunc.mapObj.mapReadOnly(this.disabled);

    if (this.disabled == false) {
      this.mapFunc.setActivateButtonLookupAddress();
    }
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
  onMoveEnd(evt) {
    if (this.isMapReady == null) {
      this.isMapReady = setInterval( this.mapReady.bind(this), 200);
    }
  }
  onMapWheelScroll(evt) {
    this.hasMapWheelScroll = true;
    this.mapFunc.subLabelTiming = "On-Map-Wheel-Scroll";
  }
  mapReady() {
    if (this.mapFunc.mapObj.isMapReady) {
      this.mapFunc.resetupTooltipUI();
      clearInterval(this.isMapReady);
      this.isMapReady = null; // reset
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        if (this.mapFunc?.hasMapDragging == true) {
          this.mapFunc.hasMapDragging = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else if (this.mapFunc.mapObj.hasClickButtonZoom == true) {
          this.mapFunc.mapObj.hasClickButtonZoom = false; // reset
          this.loadAsset('click zoom button & mapMoveEnd', false);
        } else if (this.mapFunc.hasResize === true) {
          this.mapFunc.hasResize = false; // reset
          this.loadAsset('has resize window & mapMoveEnd', false);
        } else if(this.mapFunc.hasMapWrapperResize) {
          this.mapFunc.hasMapWrapperResize = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else if (this.hasMapWheelScroll) {
          this.hasMapWheelScroll = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else {
          console.log(`**** CASE : has "map move end" event but don\'t load asset`);
        }
      } else {
        this.loadAsset('mapMoveEnd', false);
      }

      this.resetMapAction();
    }
  }
  resetMapAction() {
    this.mapFunc.subLabelTiming = 'Unknow-Source'; // reset
    this.mapFunc.hasMapDragging = false;
    this.mapFunc.mapObj.hasClickButtonZoom = false;
    this.mapFunc.hasResize = false;
    this.hasMapWheelScroll = false;
  }

  selectAssetPopup() {

  }

  getHTMLClusterMarkers(features) {
    if (features === undefined || features.length === 0) {
      return;
    }

    this.clusterList = [];
    let isDisplayOnly = true;
    let currentAssets;
    // if (this.isPrimaryAsset) {
    //   currentAssets = this.assets.primary;
    // } else if (this.isSecondaryAsset) {
    //   currentAssets = this.assets.secondary;
    // }
    for (let i = 0; i < features.length; i++) {
      const feature = features[i];
      const properties = this.mapFunc.mapObj.getFeatureProperties(feature, ['name', 'id', 'layerDisplayOnly', 'url']);
      const name = properties.name;
      const docId = properties.id;
      const exist = this.mapFunc.isContainFeature(docId, currentAssets);
      let check = '';
      if (exist) {
        check = 'checked';
      }
      const id = this.keyName + i + 'cluster';
      const cbName = this.keyName + 'cluster';
      let html = '';
      html += '<span id =  \'' + docId + '\'>' + name + '</span>';

      this.allowSelectAsset = isDisplayOnly;

      this.clusterList.push(html);
    }


    this.mapFunc.showPopupClusters();
    this.cdRef.detectChanges();
  }
  closeClusterPopup(isMultiMode) {
    if (isMultiMode) {
      const id = this.keyName + 'cluster';
      const assets = []; const selectedFeatures = [];
      const selectedAssetIds = [];
      const unSelectedAssetIds = [];
      const assetsCoord = [];
      const coor = this.mapFunc.mapObj.getLatLngFromPixel(this.mapFunc.pixelPopup);
      let street = null;
      let feaType = MapDrawType.LINE_STRING;

      const cboxes = document.getElementsByName(id);
      const len = cboxes.length;
      for (let i = 0; i < len; i++) {
        const iCb = cboxes[i] as HTMLInputElement;
        if (iCb.checked) {
          selectedAssetIds.push(iCb.value);
        } else {
          unSelectedAssetIds.push(iCb.value);
        }
      }
      for (let i = 0; i < selectedAssetIds.length; i++) {
        const fea = this.mapFunc.mapObj.getFeatureById(selectedAssetIds[i]);
        if (fea) {
          const pro = this.mapFunc.mapObj.getFeatureProperties(fea, ['street', 'type', 'coorData']);
          street = pro.street;
          feaType = pro.type;
          if (feaType === MapDrawType.POINT) {
            const loc = pro.coorData;
            assetsCoord.push(loc) ;
          } else {
            assetsCoord.push(coor);
          }

        }
      }
      this.clusterList = []; // reset
    }
    this.isPopupClusterOpen = false;
    this.mapFunc.infoClusterPosition = {left: '0px', top: '0px'};
    this.cdRef.detectChanges();
  }

  loadAsset(fromSource, isFirstLoad) {
    this.mapFunc.loadAsset(fromSource, isFirstLoad, {});

  }

  createFeature(params) {
    const featureData = params.featureData;
    const type = params.type;
    const imageFileNo = params.imageFileNo;
    const name = params.name;
    const id = params.id;
    const color = params.color;
    const layerDisplayOnly = params.layerDisplayOnly;
    const anchor = params.anchor;
    // url
    const layerClone = params.layerClone;
    const tooltip = params.tooltip;
    const label = params.label;
    const layer = params.layer;
    const layerIndex = params.layerIndex;
    const centerPoint = params.centerPoint;
    const rotation = params.rotation;
    const scale = params.scale;
    // docId
    const radius = params.radius;
    const circleCenter = params.circleCenter;
    const handlebarsContext = params.handlebarsContext;
    const itemData = params.itemData;
    const primaryMultiPopup = params.primaryMultiPopup;
    const secondaryMultiPopup = params.secondaryMultiPopup;
    const asset = params.asset;



    const feature = this.mapFunc.mapObj.createFeatureByType(featureData.geometry.coordinates, type
      , {
          EPSG: this.mapFunc.EPSG,
          imageFileNo,
          name,
          id,
          color,
          layerDisplayOnly,
          anchor,
          url: null,
          layer: cloneDeep(layerClone),
          primaryMultiPopup,
          secondaryMultiPopup,
          label,
          layerType: layer.type,
          layerIndex,
          centerPoint,
          rotation,
          scale,
          radius,
          circleCenter
        });
    if (feature === null) {
      return null;
    }

    this.mapFunc.mapObj.setFeatureProperties(feature, {
      type: type, coorData: featureData.geometry.coordinates, itemData
    });
    const fea = this.mapFunc.mapObj.getFeatureById(id);
    if (!fea) {
      this.mapFunc.mapObj.addFeature(feature, layerIndex);
      let hbObject;
      hbObject = {};
      hbObject.id = this.mapFunc.mapObj.getFeatureId(feature);
      hbObject.tooltips = layer.tooltips;
      hbObject.layerIndex = layerIndex;
      if (tooltip) { hbObject.tooltips = tooltip; }
      hbObject.handlebarsContext = handlebarsContext;
      hbObject.contextParams = this.mapFunc.contextParams;
      if (!find(this.mapFunc.tooltipHandleBarObjects, { id, layerIndex })) {
        this.mapFunc.tooltipHandleBarObjects.push(hbObject);
      }


      if (this.layersRedraw === true) {
          if (layerIndex in this.mapFunc.mapObj.assetOfLayers) {
            this.mapFunc.mapObj.assetOfLayers[layerIndex].push(feature);
          } else {
            this.mapFunc.mapObj.assetOfLayers[layerIndex] = [feature];
          }
      }
    }

    return feature;
  }
  // street-data events
  onStreetDataComponentInit(e) {
    this.streetDataComp = e.streetDataComp;
    if (this.hasOnFieldValueChange) {
      this.hasOnFieldValueChange = false; // reset
      this.fieldValueChanged();
    }
  }

}

